module.exports = __webpack_public_path__ + "static/newsletter-icon-3d809e48fdf55dc32100b1fb03767ca9.png";